import { render, staticRenderFns } from "./Recommendation.vue?vue&type=template&id=0814549e&scoped=true&"
import script from "./Recommendation.vue?vue&type=script&lang=ts&"
export * from "./Recommendation.vue?vue&type=script&lang=ts&"
import style0 from "./Recommendation.vue?vue&type=style&index=0&id=0814549e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0814549e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAlert,VImg})
